import React, { FunctionComponent, useEffect, useState } from 'react';
import { GetCarSpecifications_customizeCar_car } from '../../../../../graphql/queries/__generated__/GetCarSpecifications';
import useCarSpecifications from '../../../../../hooks/queries/useCarSpecifications';
import SpecificationsAndFeaturesLoader from '../../../../presentational/loaders/SpecificationsAndFeaturesLoader';
import ThemedErrorMessage from '../../../../../../common/components/presentation/error/ThemedErrorMessage';
import CarSpecificationsList from './CarSpecificationsList';
import ModelSpecificationsList from './ModelSpecificationsList';

export interface IModelSpecificationsContainerProps {
  isOpen: boolean;
}

const SpecificationsListContainer: FunctionComponent<IModelSpecificationsContainerProps> = ({ isOpen }) => {
  const { data, loading, error, loadCarSpecifications } = useCarSpecifications();
  const [carSpecifications, setCarSpecifications] = useState([]);
  const [carData, setCarData] = useState<GetCarSpecifications_customizeCar_car | null>(null);

  useEffect(() => {
    if (isOpen) {
      loadCarSpecifications();
    }
  }, [isOpen, loadCarSpecifications]);

  useEffect(() => {
    if (!loading && data) {
      setCarSpecifications(data.carSpecifications);
      setCarData(data.customizeCar.car);
    }
  }, [data, loading]);

  if (loading && !data) {
    return <SpecificationsAndFeaturesLoader />;
  }

  if (error) {
    return (
      <ThemedErrorMessage
        error={error}
        fullPage={true}
        message={'trans__configurator__errors__general_error_message'}
      />
    );
  }

  return carSpecifications && carSpecifications.length ? (
    <CarSpecificationsList carSpecifications={carSpecifications} loading={loading} />
  ) : (
    carData && <ModelSpecificationsList car={carData} hasTranslation />
  );
};

export default SpecificationsListContainer;
